/* jshint esversion: 6 */

const GetPlanData = {
    lookupDetails: (level, term) => {
        let details = {
            plan_id: '',
            plan_name: '',
            price: 0
        };

        level = parseInt(level);
        term = parseInt(term);

        switch (level) {
            case 6:
                switch (term) {
                    case 1:
                        details.plan_id = 'dlvrit_pro_v2';
                        details.plan_name = 'Pro Monthly';
                        details.price = 14.99;
                        break;

                    case 2:
                        details.plan_id = 'dlvrit_pro_annual_v2';
                        details.plan_name = 'Pro Annual';
                        details.price = 129.50;
                        break;

                    default:
                        break;
                }
                break;

            case 8:
                switch (term) {
                    case 1:
                        details.plan_id = 'dlvrit_agency';
                        details.plan_name = 'Agency Monthly';
                        details.price = 199.99;
                        break;

                    case 2:
                        details.plan_id = 'dlvrit_agency_annual';
                        details.plan_name = 'Agency Annual';
                        details.price = 1795.00;
                        break;

                    default:
                        break;
                }
                break;

            case 9:
                switch (term) {
                    case 1:
                        details.plan_id = 'dlvrit_pro_plus';
                        details.plan_name = 'Plus Monthly';
                        details.price = 39.99;
                        break;

                    case 2:
                        details.plan_id = 'dlvrit_pro_plus_annual';
                        details.plan_name = 'Plus Annual';
                        details.price = 359.50;
                        break;

                    default:
                        break;
                }
                break;

            case 10:
                switch (term) {
                    case 1:
                        details.plan_id = 'dlvrit_agency_plus';
                        details.plan_name = 'Agency+ Monthly';
                        details.price = 579.50;
                        break;

                    case 2:
                        details.plan_id = 'dlvrit_agency_plus_annual';
                        details.plan_name = 'Agency+ Annual';
                        details.price = 5495.00;
                        break;

                    default:
                        break;
                }
                break;

            case 15:
                switch (term) {
                    case 1:
                        details.plan_id = 'dlvrit_basic_monthly';
                        details.plan_name = 'Basic Monthly';
                        details.price = 9.99;
                        break;

                    case 2:
                        details.plan_id = 'dlvrit_basic_annual';
                        details.plan_name = 'Basic Annual';
                        details.price = 99.00;
                        break;

                    default:
                        break;
                }
                break;

            case 16:
                switch (term) {
                    case 1:
                        details.plan_id = 'dlvrit_starter_monthly';
                        details.plan_name = 'Starter Monthly';
                        details.price = 4.99;
                        break;

                    case 2:
                        details.plan_id = 'dlvrit_starter_annual';
                        details.plan_name = 'Starter Annual';
                        details.price = 49.00;
                        break;

                    default:
                        break;
                }
                break;

            default:
            break;
        }

        return details;
    }
};

export default GetPlanData;
